import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiDocumentGetBenefitDocumentQueryResponse,
  GetApiDocumentGetBenefitDocumentQueryParams,
  GetApiDocumentGetBenefitDocument401,
  GetApiDocumentGetBenefitDocument403,
} from "../../../types/GetApiDocumentGetBenefitDocument";

export function getGetApiDocumentGetBenefitDocumentUrl() {
  return `/api/Document/get-benefit-document` as const;
}

/**
 * {@link /api/Document/get-benefit-document}
 */
export async function getApiDocumentGetBenefitDocument(
  params?: GetApiDocumentGetBenefitDocumentQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiDocumentGetBenefitDocumentQueryResponse,
    ResponseErrorConfig<
      GetApiDocumentGetBenefitDocument401 | GetApiDocumentGetBenefitDocument403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiDocumentGetBenefitDocumentUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
